import React from "react"
import { Link } from "react-router-dom"

function Post(props) {
  const post = props.post
  const date = new Date(post.createDate)
  const dateFormatted = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`

  return (
    <Link onClick={props.onClick} to={`/post/${post._id}`} className="list-group-item list-group-item-action">
      <img className="avatar-tiny" src="https://secure.gravatar.com/avatar/dde9ede862cc8f7e25ce54a74812cd58" /> <strong>{post.title}</strong>
      {"  "}
      <span className="text-muted small">
        {!props.noAuthor && <React.Fragment>by {post.author.username}</React.Fragment>} on {dateFormatted}{" "}
      </span>
    </Link>
  )
}

export default Post
